// 此文件内容为脚本生成,请勿手动修改
export const ENV_MODE: any = 'prod';
export const REGION_MODE: any = 'us';
